import { render, staticRenderFns } from "./ResendInvoiceButton.vue?vue&type=template&id=6c06c86c&scoped=true"
import script from "./ResendInvoiceButton.vue?vue&type=script&lang=ts"
export * from "./ResendInvoiceButton.vue?vue&type=script&lang=ts"
import style0 from "./ResendInvoiceButton.vue?vue&type=style&index=0&id=6c06c86c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c06c86c",
  null
  
)

export default component.exports